import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';

import { AuthService } from '../services/auth.service';

@Injectable()
export class HttpRequestInterceptor implements HttpInterceptor {
  constructor(public auth: AuthService, private translate: TranslateService) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    request = request.clone({
      setHeaders: {
        'Content-Type': 'application/json; charset=utf-8',
        'Accept-Language': this.translate.currentLang
          ? this.translate.currentLang
          : '',
        'Cache-Control': 'no-cache',
        'timeout': '90000',
        Pragma: 'no-cache',
//        Authorization: `Bearer ${this.auth.getAuthToken()}`
      }
    });

    return next.handle(request);
  }
}
